import { getPhotoRequest } from '@/fsd/entities/account/api/getPhotoRequest/getPhotoRequest';
import { useUserStore } from '@/fsd/entities/user/model/store/useUserStore';
import { routes } from '@/fsd/shared/config/routes/routesConfig';
import { Logout, Settings, User } from '@/fsd/shared/ui/icons';
import { API_URL } from '@/fsd/shared/ui/static/js/request';
import { useQuery } from '@tanstack/react-query';
import { RussianRuble } from 'lucide-react';
import { NavLink, useNavigate } from 'react-router-dom';
import style from '../header.module.scss';

export const LkMenu = () => {
  const navigate = useNavigate();
  const userStore = useUserStore();

  const { data: serverPhoto } = useQuery({
    queryKey: ['photo'],
    queryFn: getPhotoRequest,
    select: (data) => data.photo,
    refetchOnWindowFocus: false,
  });

  const handleOut = () => {
    userStore.handleOut().then(() => {
      navigate(routes.login.path);
    });
  };

  return (
    <div style={{ position: 'relative' }}>
      <div className={style.widgetLKPre}>
        {/* <User.Fallback /> */}

        {serverPhoto ? (
          <img src={`${API_URL}/${serverPhoto}`} />
        ) : (
          <User.Fallback />
        )}
      </div>
      <div className={style.subMenu}>
        <div className={style.subMenuContent}>
          {' '}
          <NavLink to="/settings/account/" className={style.widgetLKItem}>
            <User.Default
              style={{ marginLeft: '2px' }}
              width={16}
              height={16}
            />
            Учетная запись
          </NavLink>
          <NavLink to="/settings/account/" className={style.widgetLKItem}>
            <Settings width={16} height={16} />
            Настройки
          </NavLink>
          <NavLink to="/tariffs-and-payments" className={style.widgetLKItem}>
            <RussianRuble width={16} height={16} />
            Тарифы и оплата
          </NavLink>
          <div
            style={{
              border: '0.5px solid #DCE7F1',
              width: '100%',
              margin: '10px 0',
            }}
          />
          <span className={style.widgetLKItem} onClick={handleOut}>
            <Logout />
            Выйти
          </span>
        </div>
      </div>
    </div>
  );
};
